// extracted by mini-css-extract-plugin
export var chip = "_dd-0";
export var filterDropdown = "_dd-5";
export var filterItem = "_dd-6";
export var icon = "_dd-1";
export var removeButton = "_dd-3";
export var removeIcon = "_dd-4";
export var separator = "_dd-2";